import { createFileRoute, redirect } from '@tanstack/react-router'
import { IdeaDocumentPage } from '../components/services/IdeaDocument.tsx'

/**
 * A long idea as a page of its own, to read, change and print: a plan's
 * small-group guide or its kids & family devotional (docs/15).
 */
export const Route = createFileRoute('/_authed/_shell/services/plans/$id_/sermon_/$kind')({
  beforeLoad: ({ params }) => {
    if (params.kind !== 'group_guide' && params.kind !== 'family')
      throw redirect({ to: '/services/plans/$id/sermon', params: { id: params.id }, replace: true })
  },
  component: IdeaDocumentScreen,
})

function IdeaDocumentScreen() {
  const { id, kind } = Route.useParams()
  return <IdeaDocumentPage planId={id} kind={kind === 'family' ? 'family' : 'group_guide'} />
}
